<template>
  <div class="bulk-toolbar">
    <div class="bulk-toolbar__count">
      <i class="fa-solid fa-circle-check" />
      <span>{{ count }}<span class="opacity-50">/{{ total }}</span></span>
    </div>

    <div class="bulk-toolbar__actions">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary rounded-3"
        :disabled="busy || !total"
        @click="$emit('toggle-all')"
      >
        <i class="fa-solid" :class="allSelected ? 'fa-xmark' : 'fa-check-double'" />
        <span class="d-none d-sm-inline ms-1">{{ allSelected ? $t('Clear') : $t('Select All') }}</span>
      </button>

      <!-- Action menu: enabled entries depend on what's selected -->
      <div class="dropdown">
        <button
          type="button"
          class="btn btn-sm btn-theme fw-bold rounded-3 dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          :disabled="busy || !count"
        >
          <i class="fa-solid fa-spinner fa-spin me-1" v-if="busy" />
          <i class="fa-solid fa-bolt me-1" v-else />
          {{ busy ? (busyLabel || $t('Processing') + '…') : $t('Manage') }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li v-if="showPrintQr">
            <button class="dropdown-item d-flex justify-content-between align-items-center" type="button" :disabled="!qrCount" @click="$emit('print-qr')">
              <span><i class="fa-solid fa-qrcode me-2" />{{ $t('Print QR Code') }}</span>
              <span class="badge bg-secondary ms-3">{{ qrCount }}</span>
            </button>
          </li>
          <li v-if="showOpen">
            <button class="dropdown-item d-flex justify-content-between align-items-center" type="button" :disabled="!openCount" @click="$emit('open')">
              <span><i class="fa-solid fa-door-open me-2" />{{ $t('Open Session') }}</span>
              <span class="badge bg-secondary ms-3">{{ openCount }}</span>
            </button>
          </li>
          <li>
            <button class="dropdown-item text-danger d-flex justify-content-between align-items-center" type="button" :disabled="!closeCount" @click="$emit('close')">
              <span><i class="fa-solid fa-flag-checkered me-2" />{{ $t('End Service') }}</span>
              <span class="badge bg-danger ms-3">{{ closeCount }}</span>
            </button>
          </li>
        </ul>
      </div>

      <button
        type="button"
        class="btn btn-sm btn-light border rounded-3"
        :disabled="busy"
        @click="$emit('cancel')"
        :title="$t('Cancel')"
      >
        <i class="fa-solid fa-xmark" />
      </button>
    </div>
  </div>
</template>
<script lang="js">
// Inline selection toolbar for the in-page "select & bulk actions" mode. Lives
// in the page header while selecting, styled as one cohesive bar. The "Manage"
// dropdown lists the bulk actions; each is enabled only when the selection has
// eligible items (counts come from the host page). Printer pairing lives on the
// POS printer settings page, not here.
export default {
  props: {
    count: { type: Number, default: 0 },        // total selected
    total: { type: Number, default: 0 },        // total selectable
    allSelected: { type: Boolean, default: false },
    qrCount: { type: Number, default: 0 },      // selected that can print QR (active)
    openCount: { type: Number, default: 0 },    // selected that can be opened (available tables)
    closeCount: { type: Number, default: 0 },   // selected that can be closed (active)
    showOpen: { type: Boolean, default: false },// only the Tables page can "open"
    showPrintQr: { type: Boolean, default: true }, // แพ็กไม่มี feature_qr_ordering = ไม่มีเมนูพิมพ์ QR
    busy: { type: Boolean, default: false },
    busyLabel: { type: String, default: '' },
  },
};
</script>
<style scoped>
/* One cohesive selection bar — orange-tinted so it reads as a distinct mode,
   full-width on mobile so the buttons line up instead of wrapping loosely. */
.bulk-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 6px 8px 6px 12px;
  background: rgba(233, 108, 21, .08);
  border: 1px solid rgba(233, 108, 21, .28);
  border-radius: 12px;
}
.bulk-toolbar__count {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  white-space: nowrap;
  color: #d46010;
}
.bulk-toolbar__count i {
  color: #E96C15;
}
.bulk-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
@media (min-width: 1200px) {
  /* in the desktop header row the bar shouldn't stretch edge-to-edge */
  .bulk-toolbar {
    width: auto;
  }
}
</style>
